module.exports = __webpack_public_path__ + "img/PEBL-Logo-Color-small.dd115419.png";